import { styled } from '@mui/material';
import clsx from 'clsx';

import { Button, ButtonProps, buttonVars } from '@cast/design-system';

type HeaderButtonProps = {
  active?: boolean;
} & Omit<ButtonProps, 'size' | 'variant'>;

export const HeaderButton = styled(
  ({ className, active, children, ...rest }: HeaderButtonProps) => {
    return (
      <Button
        {...rest}
        className={clsx(className, { active }, 'TopNavHeaderButton-root')}
        size="sm"
      >
        {children}
      </Button>
    );
  }
)(({ theme, children, startIcon }) => ({
  ...buttonVars.setValues({
    color: theme.palette.grey[600],
    colorHover: theme.palette.grey[600],
    colorActive: theme.palette.blue[600],
    colorDisabled: theme.palette.grey[300],
    background: 'unset',
    backgroundHover: theme.palette.grey[200],
    backgroundActive: theme.palette.blue[100],
    backgroundDisabled: 'unset',
    iconSize: '20px',
    iconGap: !children && !!startIcon ? 0 : undefined,
  }),

  ...theme.typography.P14M,

  '&.active': {
    color: buttonVars.getters.colorActive(),
    background: buttonVars.getters.backgroundActive(),
  },
}));
